import {classNames} from "../../utils/classNames";
import {SearchIcon} from "@heroicons/react/solid";
import InputMask from 'react-input-mask';
import {useField} from "formik";
import {useLocation} from "react-router-dom";

export function SearchInput(
    {
        field,
        form,
        ...props
    }
) {
    const [fieldData, meta, helpers] = useField(field.name);

    const location = new URLSearchParams(useLocation().search);


    const handleChange = (event) => {
        helpers.setTouched(true);
        // location.append('search', event.target.value)

        helpers.setValue(event.target.value);
    }
    return field ? (
        <>
            <div
                className={classNames(form?.errors[field.name] && form?.touched[field.name] ? 'border-red-300' : 'border-gray-300', "relative border bg-white rounded-lg px-4 w-full lg:w-1/2 py-2 shadow-sm focus-within:border-gray-300")}>
                <label
                    htmlFor={field?.name}
                    className="block bg-white text-xs text-gray-500"
                >
                    {props.label}
                </label>
                {props.mask ? (
                    <InputMask
                        onChange={handleChange}
                        type="text"
                        {...field}
                        value={field.value}
                        id={field?.name}
                        className={'block w-full border-0 p-0 text-gray-900 placeholder-gray-500 sm:text-lg'}
                        {...props}
                    />
                ) : (
                    <input
                        type="text"
                        {...field}
                        onChange={handleChange}
                        value={field.value}
                        id={field?.name}
                        className={'block w-full border-0 p-0 text-gray-900 focus:outline-none placeholder-gray-500 sm:text-lg'}
                        {...props}
                    />
                )}

                <div className="absolute inset-y-0 right-0 pr-5 flex items-center pointer-events-none">
                    <SearchIcon className="h-7 w-7 text-gray-400" aria-hidden="true"/>
                </div>

                {/*{ !form.errors[field.name] && form.touched[field.name] && (<CheckIcon className="absolute top-0 right-4 transform translate-y-1/2 h-8 w-8 text-green-500 opacity-50" aria-hidden="true" />)}*/}
            </div>
        </>
    ) : ''
}
